import { Button, Modal, Text } from "@marketplace/ui";
import { notifications } from "@marketplace/ui/notifications";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import { deleteVoucherModalAtom } from "../../atoms";
import { useDeleteVoucherMutation } from "../../hooks/mutations/use-delete-voucher-mutation";

type DeleteVoucherModalProps = {
  opened: boolean;
  onClose: () => void;
};

export const DeleteVoucherModal = ({
  opened,
  onClose
}: DeleteVoucherModalProps) => {
  const { t: tVoucher } = useTranslation("voucher");
  const { t: tCommon } = useTranslation("common");
  const { data } = useAtomValue(deleteVoucherModalAtom);

  const { mutateAsync: mutateDeleteVoucher, isPending } =
    useDeleteVoucherMutation();

  const handleDelete = async () => {
    try {
      if (!data?.id) return;

      await mutateDeleteVoucher({ voucherId: data.id });

      notifications.show({
        message: tVoucher("notifications.successDeleteVoucher")
      });
      onClose();
    } catch {
      notifications.show({
        variant: "error",
        message: tVoucher("notifications.failedToDeleteVoucher")
      });
    }
  };

  return (
    <Modal.Root opened={opened} onClose={onClose} size={334}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Body classNames={{ body: "!p-[42px]" }}>
          <Text type="paragraph" className="text-center mb-6">
            {tVoucher("modal.deleteVoucherModal.description", {
              voucherCode: data?.voucher_code
            })}
          </Text>
          <div className="flex gap-x-[14px]">
            <Button variant="secondary" fullWidth onClick={onClose}>
              {tCommon("no")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              loading={isPending}
              onClick={handleDelete}
            >
              {tCommon("yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
